import React from 'react';
import { NavLink } from 'react-router-dom';

const TombstonesCrumb = () => <NavLink to="/core/tombstones">Tombstones</NavLink>;

export default TombstonesCrumb;
